export const formatGermanCountryCode = (phoneNumber: string): string => {
    return phoneNumber.replace(/^(\+49|49)/, '0');
};

export const trimPhoneNumber = (phoneNumber: string): string => {
    return phoneNumber.replace(/\s+/g, '');
};

// Formats a phone number by trimming spaces and replacing the German country code with '0'
export const formatPhoneNumber = (phoneNumber: string): string => {
    const trimmed = trimPhoneNumber(phoneNumber);
    return formatGermanCountryCode(trimmed);
};
